import {
  Box,
  Center,
  Group,
  keys,
  LoadingOverlay,
  Pagination,
  ScrollArea,
  Select,
  Table,
  Text,
  TextInput,
  UnstyledButton,
} from "@mantine/core";
import React, { useEffect, useReducer, useState } from "react";
import { useParams } from "react-router-dom";
import { url } from "../../settings/linkUrl";
import {
  IconSelector,
  IconChevronDown,
  IconChevronUp,
  IconSearch,
} from "@tabler/icons-react";
import ShowCard from "../administrator-card/components/ShowCard";
import RemoveRegsiter from "./RemoveRegsiter";
import chrome from "../AdminPageChrome.module.css";

interface RowData {
  stdid: string;
  number_true: string;
  name: string;
  lname: string;
  vut: string;
  citizen: string;
  levelk: string;
  programe: string;
  yearrub: string;
  creck: string;
}

interface ThProps {
  children: React.ReactNode;
  reversed: boolean;
  sorted: boolean;
  onSort(): void;
}

export default function AdministratorClearregister() {
  let { id } = useParams();

  useEffect(() => {
    LoadPage();
  }, [id]);

  const [search, setSearch] = useState("");

  const [dataList, setDataList] = useState<RowData[]>([]);
  const [sortedData, setSortedData] = useState<RowData[]>([]);

  const [sortBy, setSortBy] = useState<keyof RowData | null>(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);

  const initialState = {
    loading: "",
    error: "",
    data: [],
  };

  function apiReducer(state: any, action: any) {
    switch (action.type) {
      case "DATA_FETCH_START":
        return { ...state, loading: "yes" };
      case "DATA_FETCH_SUCCESS":
        return { ...state, loading: "", data: action.payload };
      case "DATA_FETCH_FAILURE":
        return { ...state, loading: "", error: action.payload };
      default:
        return state;
    }
  }

  function sortData(
    data: RowData[],
    payload: { sortBy: keyof RowData | null; reversed: boolean; search: string }
  ) {
    const { sortBy } = payload;
    if (!sortBy) {
      return filterData(data, payload.search);
    }

    return filterData(
      [...data].sort((a, b) => {
        if (payload.reversed) {
          return b[sortBy].localeCompare(a[sortBy]);
        }
        return a[sortBy].localeCompare(b[sortBy]);
      }),
      payload.search
    );
  }

  function filterData(data: RowData[], search: string) {
    const query = search.toLowerCase().trim();
    return data.filter((item) =>
      keys(data[0]).some((key) =>
        String(item[key] ?? "")
          .toLowerCase()
          .includes(query)
      )
    );
  }

  function Th({ children, reversed, sorted, onSort }: ThProps) {
    const Icon = sorted
      ? reversed
        ? IconChevronUp
        : IconChevronDown
      : IconSelector;
    return (
      <Table.Th>
        <UnstyledButton onClick={onSort}>
          <Group gap={4} wrap="nowrap">
            <Text fw={600} fz="sm">
              {children}
            </Text>
            <Center>
              <Icon size="0.9rem" stroke={1.5} />
            </Center>
          </Group>
        </UnstyledButton>
      </Table.Th>
    );
  }

  const [data, dispatch] = useReducer(apiReducer, initialState);

  const LoadPage = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}Listname/ListnameRegister`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        setSortedData(json);
        setDataList(json);
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  useEffect(() => {
    LoadPage();
  }, []);

  const setSorting = (field: keyof RowData) => {
    const reversed = field === sortBy ? !reverseSortDirection : false;
    setReverseSortDirection(reversed);
    setSortBy(field);
    setSortedData(sortData(sortedData, { sortBy: field, reversed, search }));
  };

  const logMessage = () => {
    LoadPage();
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;
    setSearch(value);
    setSortedData(
      sortData(dataList, {
        sortBy,
        reversed: reverseSortDirection,
        search: value,
      })
    );
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setitemsPerPage] = useState(50);
  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;
  const currentUsers = sortedData.slice(indexOfFirstUser, indexOfLastUser);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < Math.ceil(sortedData.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const setitemsPerPageInt = (e: any) => {
    let i = parseInt(e.toString());
    setitemsPerPage(i);
    handlePageChange(1);
    setCurrentPage(1);
  };

  const startIndex = Math.max(currentPage - Math.floor(itemsPerPage / 2), 1);
  const endIndex = Math.min(
    startIndex + itemsPerPage - 1,
    Math.ceil(sortedData.length / itemsPerPage)
  );

  const rows = currentUsers.map((element: any, index) => (
    <Table.Tr key={element.stdid}>
      <Table.Td style={{ textAlign: "center" }} width={50}>
        {indexOfFirstUser + index + 1}
      </Table.Td>
      <Table.Td style={{ textAlign: "center" }} width={72}>
        <ShowCard url={`${element.picture}`} data={element} />
      </Table.Td>
      <Table.Td>{element.stdid}</Table.Td>
      <Table.Td>{element.citizen}</Table.Td>
      <Table.Td>{element.number_true}</Table.Td>
      <Table.Td>
        {element.name} {element.lname}
      </Table.Td>
      <Table.Td>{element.vut}</Table.Td>
      <Table.Td>{element.levelk}</Table.Td>
      <Table.Td>{element.programe}</Table.Td>
      <Table.Td style={{ textAlign: "center" }} width={120}>
        <RemoveRegsiter
          id={element.stdid}
          path="Listname/DeleteListnameRegister"
          onLoadPage={logMessage}
        />
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <>
      <LoadingOverlay visible={!!data.loading} />
      <header className={chrome.pageHeader}>
        <h1 className={chrome.title}>ล้างข้อมูลการลงทะเบียน</h1>
        <p className={chrome.subtitle}>
          รายชื่อผู้ที่ลงทะเบียนแล้ว — ลบข้อมูลด้วยความระมัดระวัง
        </p>
      </header>

      <div className="admin-toolbar">
        <Text size="sm" c="dimmed">
          ทั้งหมด {sortedData.length} รายการ
        </Text>
        <TextInput
          className={chrome.searchInput}
          placeholder="ค้นหาด้วยรหัส ชื่อ หรือเลขประชาชน"
          leftSection={<IconSearch size="0.9rem" stroke={1.5} />}
          value={search}
          onChange={handleSearchChange}
        />
      </div>

      <div className="admin-table-wrap">
        <ScrollArea>
          <Table fz="sm" striped highlightOnHover withRowBorders>
            <Table.Thead>
              <Table.Tr>
                <Table.Th style={{ textAlign: "center" }}>#</Table.Th>
                <Table.Th style={{ textAlign: "center" }}>รูปภาพ</Table.Th>
                <Th
                  sorted={sortBy === "stdid"}
                  reversed={reverseSortDirection}
                  onSort={() => setSorting("stdid")}
                >
                  รหัสประจำตัว
                </Th>
                <Th
                  sorted={sortBy === "citizen"}
                  reversed={reverseSortDirection}
                  onSort={() => setSorting("citizen")}
                >
                  รหัสประจำตัวประชาชน
                </Th>
                <Th
                  sorted={sortBy === "number_true"}
                  reversed={reverseSortDirection}
                  onSort={() => setSorting("number_true")}
                >
                  ลำดับ
                </Th>
                <Th
                  sorted={sortBy === "name"}
                  reversed={reverseSortDirection}
                  onSort={() => setSorting("name")}
                >
                  ชื่อ - นามสกุล
                </Th>
                <Th
                  sorted={sortBy === "vut"}
                  reversed={reverseSortDirection}
                  onSort={() => setSorting("vut")}
                >
                  วุฒิ
                </Th>
                <Th
                  sorted={sortBy === "levelk"}
                  reversed={reverseSortDirection}
                  onSort={() => setSorting("levelk")}
                >
                  คณะ
                </Th>
                <Th
                  sorted={sortBy === "programe"}
                  reversed={reverseSortDirection}
                  onSort={() => setSorting("programe")}
                >
                  สาขาวิชา
                </Th>
                <Table.Th style={{ textAlign: "center" }}>จัดการ</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {rows.length > 0 ? (
                rows
              ) : (
                <Table.Tr>
                  <Table.Td colSpan={10}>
                    <div className="admin-empty">ไม่พบข้อมูล</div>
                  </Table.Td>
                </Table.Tr>
              )}
            </Table.Tbody>
          </Table>
        </ScrollArea>
      </div>

      <Box className={chrome.footerBar}>
        <Select
          style={{ width: "110px" }}
          size="sm"
          label="แสดง"
          onChange={setitemsPerPageInt}
          value={itemsPerPage.toString()}
          data={[
            { value: "5", label: "5" },
            { value: "10", label: "10" },
            { value: "20", label: "20" },
            { value: `${Math.max(sortedData.length, 1)}`, label: "ทั้งหมด" },
          ]}
        />
        <Pagination
          withEdges
          total={endIndex}
          size="sm"
          color="blue"
          onNextPage={() => goToNextPage()}
          onPreviousPage={() => goToPrevPage()}
          onChange={handlePageChange}
        />
      </Box>
    </>
  );
}
